import { escapedRegex } from 'utils';

export const getUnits = ({ pageNumber, units, searchTerm, properties, selectedUnitIds }) => {
  return getFilteredUnits({ units, searchTerm, properties, selectedUnitIds }).slice(0, pageNumber * 10);
};

export const getFilteredUnits = ({ units, searchTerm, properties, selectedUnitIds }) => {
  return units.filter(u => {
    let property = properties.find(p => p.id === u.property_id);
    return (escapedRegex(searchTerm).test(u.number) || escapedRegex(searchTerm).test(u.property)) && !!property && !selectedUnitIds.includes(u.id);
  })
};